import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { ProductCard } from "../components/ProductCard";
import { InstagramGallery } from "../components/InstagramGallery";
import { useCategories } from "../context/CategoryContext";

import HERO from "../assets/hero.jpg";

const Home = () => {
  const { t, lang } = useLanguage();
  const { groups } = useCategories();
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then(({ data }) => setFeatured(data.slice(0, 6)));
  }, []);

  return (
    <div data-testid="home-page">
      {/* HERO */}
      {/* Şəkil şaquli formatdadır (1149×1369) və içində mətn var. Geniş zolağa
          "doldursaq" yuxarı-aşağı kəsilir və "Sparkle" yazısı itir — ona görə
          şəkil bütöv göstərilir. Yanlardakı boşluğu eyni şəklin bulanıq
          böyüdülmüş nüsxəsi doldurur, beləliklə kənarlar təbii davam edir. */}
      <section className="relative w-full overflow-hidden bg-[#6A6D70]">
        <img
          src={HERO}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-80"
        />

        <motion.img
          initial={{ opacity: 0, scale: 1.02 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          src={HERO}
          alt={t("hero_sub")}
          fetchpriority="high"
          className="relative mx-auto block w-auto max-w-full max-h-[86vh]"
          data-testid="hero-image"
        />
      </section>

      {/* Başlıq şəklin içindədir; Google və ekran oxuyucuları üçün burada
          görünməz mətn kimi saxlanılır. */}
      <h1 className="sr-only">
        {t("hero_title")} — {t("hero_sub")}
      </h1>

      <div className="flex flex-wrap gap-4 justify-center px-6 py-10 bg-brand-bg">
        <Link
          data-testid="hero-shop-button"
          to="/shop"
          className="bg-brand-ink text-white px-8 py-4 text-sm tracking-[0.12em] uppercase border border-brand-ink hover:bg-brand-bg hover:text-brand-ink transition-colors"
        >
          {t("hero_cta")}
        </Link>
        <Link
          to={groups[0] ? `/shop?group=${encodeURIComponent(groups[0].key)}` : "/shop"}
          className="border border-brand-line text-brand-ink px-8 py-4 text-sm tracking-[0.12em] uppercase hover:border-brand-ink transition-colors"
        >
          {t("hero_cta2")}
        </Link>
      </div>

      {/* MARQUEE */}
      <div className="bg-brand-ink text-brand-bg overflow-hidden py-4">
        <div className="flex whitespace-nowrap animate-marquee">
          {Array(2).fill(0).map((_, k) => (
            <div key={k} className="flex shrink-0">
              {["925 Əyar Gümüş", "SPARKLE COLLECTION", "STERLING SILVER"].map((s, i) => (
                <span key={i} className="overline text-white/60 mx-8">{s} ✦</span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* FEATURED */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24">
        <div className="flex items-end justify-between mb-16">
          <div>
            <p className="overline mb-3">Sparkle</p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight">{t("featured")}</h2>
          </div>
          <Link to="/shop" className="hidden sm:flex items-center gap-2 overline hover:text-brand-ink group">
            {t("view_all")} <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-16 gap-x-8">
          {featured.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </section>

      {/* INSTAGRAM */}
      <InstagramGallery />
    </div>
  );
};

export default Home;
